/**
 * Route for `dashboard-export-png-pdf`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DashboardExportPngPdfPage } from "../features/dashboard-export-png-pdf/DashboardExportPngPdfPage";

export const dashboardExportPngPdfRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/dashboard-export-png-pdf",
	component: DashboardExportPngPdfPage,
});

export default dashboardExportPngPdfRoute;
